import { useQuery } from 'react-query'
import { logFactory } from '../../util'
import { useAppointmentsService } from '../services'
import { GetCalendarIntegrationAppointmentTypeMappingsResponse } from '../../types/calendarIntegrationAppointmentTypeMapping'
import { CalendarIntegrationAppointmentTypeMappingsFilters } from '../services/appointments/calendarIntegrationAppointmentTypeMappings'

const hookName = 'useCalendarIntegrationAppointmentTypeMappings'
const log = logFactory(hookName)

const useCalendarIntegrationAppointmentTypeMappings = (filters: CalendarIntegrationAppointmentTypeMappingsFilters, enabled = true) => {
  const { getCalendarIntegrationAppointmentTypeMappings, isReady } = useAppointmentsService()

  const doQuery = async (): Promise<GetCalendarIntegrationAppointmentTypeMappingsResponse> => {
    log(`📆 Fetching calendar integration appointment type mappings...`, filters)

    const results = await getCalendarIntegrationAppointmentTypeMappings(filters)

    log(`📆 Returned calendar integration appointment type mappings...`, results)

    return results
  }

  return useQuery([hookName, filters], doQuery, {
    enabled: isReady && enabled && Boolean(filters.shop_id),
  })
}

export { useCalendarIntegrationAppointmentTypeMappings }
